export default __webpack_public_path__ + "static/media/menu-fold-icons.f1edd608.svg";